import React, { useState } from 'react';
import { useParams } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import productosPriveCollection from '../data/todosLosProductos/productosPriveCollection';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import Footer from '../componentes/Footer';

import { FichaProducto, Galeria, MotionImagen, Flecha, Miniaturas, Miniatura } from '../elementos/GaleriaStyles';

const DetallesPriveCollection = () => {
  const { categoriaSlug, slug } = useParams();

  const producto = productosPriveCollection.find(
     p => p.categoriaSlug === categoriaSlug && p.slug === slug
  );

  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0);
  const [animando, setAnimando] = useState(false);

  if (!producto) return <h2>Producto no encontrado</h2>;

  const imagenActual = producto.images[indiceSeleccionado];
  const imagenDeMuestra = producto.images[0];
  const imagenesDeColores = producto.images.slice(1);

  const cambiarImagen = (index) => {
    if (index >= 0 && index < producto.images.length) {
      setAnimando(true);
      setTimeout(() => {
        setIndiceSeleccionado(index);
        setAnimando(false);
      }, 50); 
    }
  };

  return (
    <>
    <Header />
    <AnimacionPagina>
      <FichaProducto>
      <h1>{producto.nombre}</h1>
      <h3>Colección Prive - {producto.categoria}</h3>
      
      {/* Nuevos datos renderizados */}
      <div style={{ marginBottom: '20px' }}>
          <p><strong>Ancho de rollo:</strong> {producto.anchoTela} m</p>
          <p><strong>Sistema:</strong> {producto.sistema}</p>
          <p><strong>Tipo:</strong> {producto.caracteristica}</p>
          <p><strong>Atributos:</strong> {producto.textura}</p>
          <p style={{ fontStyle: 'italic', marginTop: '10px', color: '#555' }}>
            "{producto.descripcionExtra}"
          </p>
      </div>

      <Galeria>
        <Flecha className='flechaBack' onClick={() => cambiarImagen(indiceSeleccionado - 1)}>&larr;</Flecha>
        <AnimatePresence mode="wait">
          <MotionImagen
            key={imagenActual}
            src={imagenActual}
            alt="Imagen seleccionada"
            initial={{ opacity: .5, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
          />
        </AnimatePresence>
        <Flecha className='flechaSig' onClick={() => cambiarImagen(indiceSeleccionado + 1)}>&rarr;</Flecha>
      </Galeria>

      <h2>Colores de tela:</h2>
      <Miniaturas> 
        <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.7 }}
        >
          <Miniatura
            activa={indiceSeleccionado === 0}
            onClick={() => cambiarImagen(0)}
          >
            <img src={imagenDeMuestra} alt="Muestra" />
            <span>Muestra</span>
          </Miniatura>
        </motion.div>
        
        {producto.colores.map((color, i) => (
        <motion.div
          key={color}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.7 }}
          >
          <Miniatura
            activa={indiceSeleccionado === i + 1}
            onClick={() => cambiarImagen(i + 1)}
          >
            <img src={imagenesDeColores[i]} alt={color} />
            <span>{color}</span>
          </Miniatura>
        </motion.div>
        ))}
      </Miniaturas>
      
      <BtnVolverAnim Ref='/prive-collection' />
      <WhatsAppShareButton message={`¡Mira esta tela de la Prive Collection: ${producto.nombre}!`} />
      </FichaProducto>
      <Footer />
    </AnimacionPagina>
    </>
  );
};

export default DetallesPriveCollection;